var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2c-.464 0-.91.176-1.237.488A1.627 1.627 0 000 3.667v6.666c0 .442.184.866.513 1.179.328.312.773.488 1.237.488h10.5c.464 0 .91-.176 1.237-.488.329-.313.513-.737.513-1.179V3.667c0-.442-.184-.866-.513-1.179A1.795 1.795 0 0012.25 2H1.75zM7 10.333a.449.449 0 01-.31-.122.407.407 0 01-.128-.294V5.089l-1.44 1.373a.44.44 0 01-.31.122.457.457 0 01-.31-.122.416.416 0 01-.128-.295.4.4 0 01.129-.295L6.69 3.788A.44.44 0 017 3.666a.456.456 0 01.31.122l2.187 2.084a.407.407 0 01.129.295c0 .11-.047.216-.129.295a.45.45 0 01-.31.122.45.45 0 01-.31-.122l-1.44-1.373v4.828c0 .11-.046.216-.128.294a.449.449 0 01-.309.122z"
  })));
}
export default SvgScreenShare;